import { Navigate } from "react-router-dom";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

interface Props {
  flag: string;
  children: React.ReactNode;
  /** Route de fallback quand le flag n'est pas accordé. */
  redirectTo?: string;
}

/**
 * Protège une route derrière un feature flag. Si l'utilisateur n'a pas le flag,
 * il est redirigé vers `redirectTo` (par défaut /dashboard).
 */
export default function FeatureRoute({ flag, children, redirectTo = "/dashboard" }: Props) {
  const { data: flags, isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <div className="flex h-[60vh] items-center justify-center">
        <div className="animate-spin h-6 w-6 border-2 border-gold border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!flags?.has(flag)) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
}
